// PreventiApp — Landing · CTA "ACCEDER"
// Redirección inteligente a la plataforma SaaS.
//
// La detección de sesión activa se realiza en el dominio destino
// (app.preventiapp.com), no en la landing:
//   • `preventiapp.com` y `app.preventiapp.com` NO comparten localStorage
//     (aislamiento por origen), por lo que aquí no podemos leer el token.
//   • En destino, `RequireAuth` + `SmartHome` deciden:
//       — sesión activa + rol admin/inside  → /admin
//       — sesión activa + rol operativo     → / (MobileApp)
//       — sin sesión                        → /login
//
// Aquí sólo:
//   1) emitimos `access_click` (tracking)
//   2) intentamos abrir la PWA instalada si está disponible (mismo origen /
//      manifest apunta al subdominio). Los navegadores modernos capturan la
//      URL automáticamente si la PWA está instalada; no hace falta código.
//   3) navegamos.

import { trackEvent } from './tracking';

export const APP_URL = process.env.REACT_APP_SAAS_URL || 'https://app.preventiapp.com';

/**
 * @param {'header'|'hero'|'navbar-mobile'|string} location
 */
export function goToApp(location = 'unknown') {
  trackEvent('access_click', { location, href: APP_URL });
  // Navegación estándar. Si el navegador tiene la PWA de app.preventiapp.com
  // instalada y configurada como URL handler, capturará la navegación
  // automáticamente (Chrome/Edge Android, iOS Safari con "Home Screen").
  window.location.href = APP_URL;
}
